import { render, staticRenderFns } from "./SubscriptionHistoryTableRow.vue?vue&type=template&id=2f08bc98&scoped=true"
import script from "./SubscriptionHistoryTableRow.vue?vue&type=script&lang=js"
export * from "./SubscriptionHistoryTableRow.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionHistoryTableRow.vue?vue&type=style&index=0&id=2f08bc98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f08bc98",
  null
  
)

export default component.exports